<template>
  <div v-if="post_detail.rate_available" >
    <div class="google-button"><img src="../assets/images/likeshare.png"/></div>
    <section class="review">
<!--      <h2 :style="campaign_theme ? rate_style : ''">Rate Us</h2>-->
      <div v-if="post_detail.google_places && post_detail.google_places !== ''" class="google-button" @click="open_link(post_detail.google_places)">
        <img src="@/assets/images/social/google-review.png" style="width: 200px"/>
      </div>
<!--      <div v-if="post_detail.yelp && post_detail.yelp !== ''"
        class="al-button yelp-color" @click="open_link(post_detail.yelp)">
        <i class="fab fa-yelp"></i> Yelp
      </div>-->
    </section>
    <section class="social">
      <div class="al-button  large-text-button ss"
           v-if="post_detail.facebook && post_detail.facebook !== ''"
           @click="open_link(post_detail.facebook)">
        <img src="@/assets/images/social/fb.png" width="42px"/>
      </div>
      <div class="al-button  large-text-button ss"
           v-if="post_detail.twitter && post_detail.twitter !== ''"
           @click="open_link(post_detail.twitter)">
        <i class="fab fa-twitter"></i>
      </div>
      <div class="al-button  large-text-button ss"
           v-if="post_detail.instagram && post_detail.instagram !== ''"
           @click="open_link(post_detail.instagram)">
        <img src="@/assets/images/social/instagram.png" width="42px"/>
      </div>
      <div class="al-button large-text-button ss"
           v-if="post_detail.yelp && post_detail.yelp !== ''"
           @click="open_link(post_detail.yelp)">
        <img src="@/assets/images/social/yelp.png" width="42px"/>
      </div>
      <div class="al-button large-text-button"
           v-if="post_detail.tiktok && post_detail.tiktok !== ''"
           @click="open_link(post_detail.tiktok)">
        <i class="fab fa-tiktok"></i>
      </div>
      <div class="al-button  large-text-button ss"
           v-if="post_detail.linkedin && post_detail.linkedin !== ''"
           @click="open_link(post_detail.linkedin)">
        <img src="@/assets/images/social/linkedin.png" width="42px"/>
      </div>
      <div class="al-button  large-text-button ss"
           v-if="post_detail.youtube && post_detail.youtube !== ''"
           @click="open_link(post_detail.youtube)">
        <img src="@/assets/images/social/youtube.png" width="42px"/>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SocialLinks',
  props: {
    post_detail: {
      type: Object
    }
  },
  computed: {
    campaign_theme () {
      return this.$store.state.campaign_theme
    },
    rate_style () {
      if (this.campaign_theme.rate) {
        return `color: ${this.campaign_theme.rate.color}; font-size: ${this.campaign_theme.rate.size}px; font-weight: ${this.campaign_theme.rate.weight};`
      } else {
        return ''
      }
    }
  },
  methods: {

    open_link (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
  .ss {
    float:left;
    background-color: transparent;
    padding: 7px !important;
  }
  .social {
    display: flex;
    justify-content: center;
    flex-wrap: wrap; /* İçeriklerin taşması durumunda alt satıra geçmesini sağlar */
  }
</style>
